import React, { useState, useRef } from 'react';
import {
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { ReactComponent as DocumentIcon } from 'assets/icons/document.svg';
import { ExpandMore } from '@material-ui/icons';
import ConfirmModal from 'Views/Common/ConfirmModal';

const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    borderRadius: 4,
    overflow: 'hidden',
    boxShadow: 'none',
    background: '#fff',
    '& .MuiButton-root': {
      border: 'none', // <- This removes the grey divider
    },
  },
  mainButton: {
    textTransform: 'none',
    background: 'linear-gradient(93deg, #53BDE7 1.06%, #4CB0D8 148.81%)',
    color: '#fff',
    fontWeight: 500,
    fontSize: 16,
    padding: '4px 12px',
    borderRadius: 4,
  },
  dropButton: {
    background: 'linear-gradient(93deg, #4CB0D8 1.06%, #9BDDFF 148.81%)',
    color: '#fff',
    padding: '8px 8px',
    borderRadius: 4,
    marginLeft: 1,
    minWidth: 40,
    '&:hover': {
      background: 'linear-gradient(93deg, #4CB0D8, #8BD0F9)',
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconItem: {
    display: 'flex',
    alignItems: 'center',
  },
  menuPaper: {
    marginTop: theme.spacing(1),
  },
}));

const ImportDropdownButton = ({
  options = [],
  label = 'Add Product',
  onSelectOption,
  isConfirmOpen,
  onConfirm,
  onCancel,
  confirmModalOptions,
  onAdd,
  editMode = false,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);

  const buttonRef = useRef(null);

  const handleOpenMenu = () => {
    setAnchorEl(buttonRef.current);
    if (buttonRef.current) {
      setMenuWidth(buttonRef.current.offsetWidth);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelect = (option) => {
    onSelectOption?.(option);
    handleCloseMenu();
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={buttonRef}
        className={classes.buttonGroup}
      >
        <Button disableRipple className={classes.mainButton} onClick={onAdd}>
          {label}
        </Button>
        {!editMode && (
          <Button className={classes.dropButton} onClick={handleOpenMenu}>
            <ExpandMore />
          </Button>
        )}
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { width: menuWidth } }}
        classes={{ paper: classes.menuPaper }}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <MenuItem key={index} onClick={() => handleSelect(option)}>
              <div className={classes.menuItem}>
                <Typography variant="body1">{option}</Typography>
              </div>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <Typography variant="body1">No Options Available</Typography>
          </MenuItem>
        )}
      </Menu>

      {confirmModalOptions && (
        <ConfirmModal
          isOpen={isConfirmOpen}
          closeModal={onCancel}
          emitConfirmEvent={onConfirm}
          isLoading={false}
          options={confirmModalOptions}
        />
      )}
    </>
  );
};

export default ImportDropdownButton;
